<div class="body-header">
  <h3 translate>verify-photo.component.title</h3>
</div>

<div class="body-content">
  <div class="content" [innerHTML]="'verify-photo.component.content' | translate"></div>

  <lv-photo-help photoType="face" lvCloseOverlay withKeyboard="esc">
    <div class="photo-wrapper">
      @if (photo) {
        <img id="the-photo" [src]="photoURL" />

        <button class="button is-secondary is-fullwidth" (click)="reset()">
          <span class="icon">
            <i lvIcon="refresh"></i>
          </span>
          <span translate>verify-photo.component.try-again</span>
        </button>
      } @else {
        <div class="svg-wrapper">
          <lv-camera-feed
            class="mirror"
            filename="face.png"
            [keepRunning]="false"
            [cameraWidth]="photoGeometry.width"
            [cameraHeight]="photoGeometry.height"
            (capture)="capture($event)"
          ></lv-camera-feed>

          <img class="svg-item" src="assets/photo-oval.svg" />
        </div>
      }

      @if (saving) {
        <div class="photo-uploading" translate>app.uploading</div>
      }
    </div>
  </lv-photo-help>
</div>

<div class="body-footer">
  @if (showNextButton) {
    <button [disabled]="nextDisabled" class="button is-primary is-fullwidth next-button" (click)="done()">
      <span translate>app.next</span>
      <span class="icon">
        <i lvIcon="long-arrow-right"></i>
      </span>
    </button>
  }
</div>
